import React from 'react'
import "./Footer.css"
const footer = () => {
    return (
        <div className="footer">
        <a href="https://github.com/pranitcode">Made by 😊 pranitcode</a>
        </div>
    )
}

export default footer
